import type {
	FieldArrayRenderProps,
	FormRenderProps,
} from "@tql/ui-components-react/kendo/form";

import type { Stop } from "~/features/ftl/shared/ftl-stop";

import { StopDetail } from "../stop-details.tsx";
import { getStopBadgeClassName } from "../stop-details-validator/stop-details-validator.ts";

export function StopDetailsArrayWrapper(
	props: Readonly<
		FieldArrayRenderProps & {
			formRenderProps: FormRenderProps;
			hasSubmitted: boolean;
		}
	>,
) {
	const stops = Array.isArray(props.value) ? (props.value as Stop[]) : [];
	return (
		<>
			{stops.map((stop, index) => {
				const badgeClassName = getStopBadgeClassName(
					props.formRenderProps,
					index,
					props.hasSubmitted,
				);

				return (
					<div key={stop.id} className={"k-col-span-1"}>
						<StopDetail
							badgeClassName={badgeClassName}
							index={index}
							stop={stop}
						/>
					</div>
				);
			})}
		</>
	);
}
